// extracted by mini-css-extract-plugin
module.exports = {"container":"BusinessUpgrade_container__3ZXls","header":"BusinessUpgrade_header__JnXO1"};